import type { DrawerPayload } from '@/features/project-board/components/DetailDrawer';
import { AiUsageFeature } from '@/features/ai-usage/feature';
import { AiUsageOperation } from '@/features/ai-usage/operation';
import type { AiUsageEvent } from '@/features/ai-usage/types';

function number(value: number | null): string {
  return value === null ? '—' : value.toLocaleString('ko-KR');
}

export class AiUsageDetail {
  static payload(event: AiUsageEvent): DrawerPayload {
    return {
      key: event.invocationId,
      kind: 'ai-usage',
      title: `${event.provider} · ${AiUsageOperation.label(event.operation)}`,
      meta: [
        { label: '요청 ID', value: event.requestId ?? '—' },
        {
          label: '기능',
          value: event.features === null ? '기록 없음' : event.features.map((feature) => AiUsageFeature.label(feature)).join(', ') || '아직 정해지지 않음',
        },
        { label: 'Slack 사용자', value: event.userId ?? '—' },
        { label: '채널 / 스레드', value: `${event.channelId ?? '—'} / ${event.threadTs ?? '—'}` },
        { label: '메시지 TS', value: event.messageTs ?? '—' },
        { label: '모델', value: event.models.join(', ') || '—' },
        { label: '입력 / 출력 토큰', value: `${number(event.inputTokens)} / ${number(event.outputTokens)}` },
        { label: '캐시 읽기 / 쓰기', value: `${number(event.cacheReadTokens)} / ${number(event.cacheWriteTokens)}` },
        { label: '비용', value: event.costUsd === null ? '—' : `$${event.costUsd.toFixed(4)}` },
        { label: '소요 시간', value: `${event.durationMs.toLocaleString()}ms` },
        { label: '상태', value: event.status },
        { label: '오류', value: event.errorType ?? '—' },
      ],
      docs: [],
      body: {
        label: '질문 · 응답',
        text: `## 질문\n\n${event.questionPreview ?? '수집되지 않음'}\n\n## 응답\n\n${event.responsePreview ?? '수집되지 않음'}`,
      },
    };
  }
}
